export default {
  TRANSFER_INFO: {
    severity: 'info' as 'info',
    title: 'Provider Transfer',
    subtitle:
      'The provider you selected had to transfer you to another provider. We will be with you shortly.'
  },
  TRANSFER_TRIAGE_INFO: {
    severity: 'info' as 'info',
    title: 'Provider Transfer',
    subtitle:
      'The provider you selected had to transfer you to another provider. We apologize for the inconvenience, but in order to best serve you we will need you to provide some information.'
  },
  TRANSFER_ERROR: {
    severity: 'error' as 'error',
    title: 'Transfer Visit Error',
    subtitle: 'Sorry, there was an issue with the transfer.'
  },
  TRANSFER_WARNING: {
    severity: 'warning' as 'warning',
    title: 'Transfer Visit Warning',
    subtitle: "The transfer has failed. Don't worry, your place in line has not changed."
  },
  PROCESS_ERROR: {
    severity: 'error' as 'error',
    title: 'Process Visit Error',
    subtitle: 'Sorry, there was an error processing the visit.'
  },
  START_ERROR: {
    severity: 'error' as 'error',
    title: 'Start Visit Error',
    subtitle: 'Sorry, there was an error starting the visit.'
  },
  DECLINED_WARNING: {
    severity: 'warning' as 'warning',
    title: 'Provider Unavailable',
    subtitle:
      'This provider is unable to see you at this time. Please find another provider and try again.'
  },
  UNSPECIFIED_ERROR: {
    severity: 'error' as 'error',
    title: 'Visit Ended'
  },
  CANCEL_WARNING: {
    severity: 'warning' as 'warning',
    title: 'Are You Sure?',
    subtitle: 'Are you sure you want to cancel your visit?'
  },
  WAITING_ROOM_PROVIDER_DETAILS: {
    ERROR: {
      title: 'Uh oh!',
      subtitle: "There was an issue fetching the selected provider's details."
    },
    NO_DATA: {
      title: 'Uh oh!',
      subtitle: 'There are no details for the selected provider.'
    }
  },
  WAITING_ROOM_VIDEO: {
    URL:
      'https://myhealthplus.intermountainhealthcare.org/static/10.24.23_ConnectCareWaitingRoomVideoForWebPatientPortal.mp4',
    SUBTITLE_OPTIONS: [
      { id: 'EngOpt', display: 'English' },
      { id: 'SpaOpt', display: 'Español' }
    ]
  },
  WAITING_ROOM_CHAT: {
    TITLE: {
      title: 'Connect Care Chat'
    },
    DEFAULT_ORDINAL: {
      ordinal: 99999999999999
    }
  }
};
